export function downloadBlob(blob: Blob, filename = 'asset') {
  const objUrl = URL.createObjectURL(blob);
  try {
    const a = document.createElement('a');
    a.href = objUrl;
    a.download = filename || 'asset';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  } finally {
    URL.revokeObjectURL(objUrl);
  }
}

export async function downloadAsset(url?: string, filename?: string) {
  if (!url) return;
  const name = filename || filenameFromURL(url) || 'asset';
  const r = await fetch(url, { mode: 'cors' });
  if (!r.ok) throw new Error(`HTTP ${r.status}`);
  downloadBlob(await r.blob(), name);
}

export function filenameFromURL(url?: string, fallback = 'asset') {
  if (!url) return fallback;
  try {
    const path = new URL(url, window.location.href).pathname;
    const name = decodeURIComponent(
      path.split('/').filter(Boolean).pop() || '',
    );
    return name || fallback;
  } catch {
    const name = decodeURIComponent(
      url.split('?')[0]?.split('/').filter(Boolean).pop() || '',
    );
    return name || fallback;
  }
}
